import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  audioReactionDialog: {
    borderRadius: "10px",
    textAlign: "center",
  },
  audioReactionDialogContent: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "19px",
    letterSpacing: "0em",
    textAlign: "center",
  },
  audioReactionDialogTitle: {
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "25px",
    letterSpacing: "0em",
    textAlign: "center",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
  },
  dialogPaper: {
    maxWidth: "420px",
  },
  closeIcon: {
    cursor: "pointer",
  },
}));
